module.exports = __webpack_public_path__ + "static/media/acceuil_5.bdf4b26b.jpg";